import { useCallback, useMemo } from 'react';
import type { RichEditorImageUploadHandler } from '@odo/shared-ui';
import { useVirtualAppointmentTypes } from '../../hooks/useVirtualAppointments';
import { uploadInternalImage } from '../../services/internalImages';
import type { VirtualAppointmentTypeOptions } from './VirtualAppointmentTypeField';

// The type dropdown's options for VirtualAppointmentEditor, wherever the editor is hosted.
export function useVirtualAppointmentTypeOptions(): VirtualAppointmentTypeOptions {
    const { data, isLoading, isError, refetch } = useVirtualAppointmentTypes();
    return useMemo(
        () => ({ types: data ?? [], isLoading, isError, onRetry: () => void refetch() }),
        [data, isLoading, isError, refetch]
    );
}

// Description images go to the patient's internal images, like every VA description.
export function useVirtualAppointmentImageUpload(patientId: string): RichEditorImageUploadHandler {
    return useCallback(
        async (file: File) => {
            const result = await uploadInternalImage(patientId, file, 'vca');
            return { url: result.url, fileId: result.fileId };
        },
        [patientId]
    );
}
